@import 'styles/mixins';
@import 'styles/variables';

.docRow {
  display: flex;

  > * {
    flex: 0 0 12%;
  }

  .newFolderInput {
    align-items: center;
    border: 1px solid var(--focus-50);
    box-shadow: 0px 0px 5px 1px var(--focus-5);
    display: flex;
    flex: 0 0 calc(40% - 12px);
    padding: 12px 12px 12px 20px;

    > * + * {
      margin-left: 8px;
    }

    input {
      flex-grow: 1;
    }

    .newFolderIcon {
      margin-left: 7px;
    }
  }
}
